<template>
  <CDialog
    @outer-click="close"
    :show="show"
    :no-header="true"
    :custom-class="'max-w-[421px]'"
  >
    <div class="flex-y-center p-5 flex-col justify-center text-center">
      <div
        class="mb-5 flex items-center justify-center w-[72px] h-[72px] p-4 bg-yellow-100 rounded-full"
      >
        <img
          src="/images/svg/toast/warning.svg"
          alt="Warning"
          class="w-full h-full object-cover"
        />
      </div>
      <div class="max-w-[381px] text-center mb-4">
        <h5 class="mb-2 text-dark-100 font-semibold text-xl">
          {{ $t("change_plan") }}
        </h5>
        <div class="text-dark text-center">
          <span class="text-sm leading-110 text-dark-200">
            {{ $t("warning_for_plan_change") }}
          </span>
        </div>
      </div>
      <div class="w-full flex-y-center gap-2">
        <CButton
          :text="$t('cancel')"
          class="w-full"
          variant="info"
          @click="close"
        />
        <CButton class="w-full" :text="$t('confirm')" @click="confirm" />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CButton from "@/components/Common/CButton.vue";

interface Props {
  show: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
  (e: "confirm"): void;
}>();

const close = () => {
  emit("close");
};
const confirm = () => {
  emit("confirm");
};
</script>

<style scoped></style>
